const REQUIRED_CONTROL_SELECTOR = 'input[required]:not([type="hidden"]), textarea[required], select[required]';
const MARKER_CLASS = 'x-required-asterisk';

function associatedLabel(control) {
  if (!control) return null;
  const wrappingLabel = control.closest?.('label');
  if (wrappingLabel) return wrappingLabel;
  if (!control.id) return null;
  const escapedId = window.CSS?.escape ? window.CSS.escape(control.id) : control.id.replace(/["\\]/g, '\\$&');
  return document.querySelector(`label[for="${escapedId}"]`);
}

function requiredControlFor(label) {
  const nested = label.querySelector(REQUIRED_CONTROL_SELECTOR);
  if (nested) return nested;
  const forId = label.getAttribute('for');
  if (!forId) return null;
  const control = document.getElementById(forId);
  return control?.matches?.(REQUIRED_CONTROL_SELECTOR) ? control : null;
}

function createMarker() {
  const marker = document.createElement('span');
  marker.className = MARKER_CLASS;
  marker.setAttribute('aria-hidden', 'true');
  marker.textContent = '*';
  return marker;
}

function titleTarget(label, control) {
  const explicitTitle = [...label.children].find((child) =>
    child !== control &&
    !child.classList.contains(MARKER_CLASS) &&
    !child.matches('input, textarea, select, button') &&
    String(child.textContent || '').trim()
  );
  if (explicitTitle) return explicitTitle;

  const textNode = [...label.childNodes].find((node) =>
    node.nodeType === Node.TEXT_NODE && String(node.textContent || '').trim()
  );
  if (!textNode) return null;
  const title = document.createElement('span');
  title.className = 'x-required-title';
  title.textContent = String(textNode.textContent || '').trim();
  textNode.replaceWith(title);
  return title;
}

function syncLabel(label) {
  if (!(label instanceof HTMLLabelElement)) return;
  const control = requiredControlFor(label);
  const marker = label.querySelector(`.${MARKER_CLASS}`);
  if (!control) {
    marker?.remove();
    label.classList.remove('x-has-required-field');
    return;
  }
  label.classList.add('x-has-required-field');
  if (marker || label.querySelector('.asterisk, [data-required-marker]')) return;
  const target = titleTarget(label, control);
  if (target) target.appendChild(createMarker());
}

function syncRequiredFieldMarkers(root = document) {
  const labels = new Set();
  if (root instanceof HTMLLabelElement) labels.add(root);
  root.querySelectorAll?.('label').forEach((label) => labels.add(label));
  root.querySelectorAll?.(REQUIRED_CONTROL_SELECTOR).forEach((control) => {
    const label = associatedLabel(control);
    if (label) labels.add(label);
  });
  labels.forEach(syncLabel);
}

export function installRequiredFieldMarkers() {
  if (window.__xcreateRequiredFieldObserver) return;
  syncRequiredFieldMarkers(document);
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      syncRequiredFieldMarkers(document);
    });
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['required', 'id', 'for'] });
  window.__xcreateRequiredFieldObserver = observer;
}
